<template>
    <div>
        <div v-if="isShownOnItemPageCount">
            <div v-for="property in propertyGroup.properties" :key="property.id" :class="paddingClasses" :style="paddingInlineStyles">
                <charity-order-property-list-item v-if="property.isShownOnItemPage && isCharityProperty(property)" :group="propertyGroup.group" :charity="getCharity(property)" :property="property"></charity-order-property-list-item>
            </div>
        </div>
    </div>
</template>

<script>
import CharityOrderPropertyListItem from "./CharityOrderPropertyListItem.vue";

export default {

    components:
    {
        CharityOrderPropertyListItem
    },

    props:
    {
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        },
        charityList: Array,
        propertyGroup: Object
    },

    computed:
    {
        isShownOnItemPageCount()
        {
            const properties = this.propertyGroup.properties.filter(property => property.isShownOnItemPage);

            return properties.length;
        }
    },
    methods:
    {
        isCharityProperty(property)
        {
          if (this.charityList){
            for(let charity of this.charityList)
            {
              if (charity.propertyId === property.id)
              {
                return true;
              }
            }
          }
          return false;
        },
        getCharity(property)
        {
            for(let charity of this.charityList)
            {
                if (charity.propertyId === property.id)
                {
                    return charity;
                }
            }
            return null;
        }
    }
}
</script>
